import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useState } from "react";
import { checkValidData, dayJsDateFormatter, getLocation } from "utils";
import { middleNameFormatter, textFormatter } from "components";
import { DateFormatess } from "helpers";
import ReportCategory from "pages/User/ReportCategory/index.page";

function AboutSection({
  memorialData,
  isModal,
  role,
  id,
}) {
  const [showReportModal, setReportModal] = useState(false);

  return (
    <>
      <div
        className="banner position-relative overflow-hidden"
        style={{
          backgroundImage: `url(${memorialData?.themeOnes?.[0]?.coverImageUrl})`,
          backgroundSize: "cover",
        }}
      >
        <div className="d-flex align-items-center banner_cnt">
          <Container>
            <div className="banner_cnt_card text-break">
              <h1>
                {checkValidData(
                  textFormatter(
                    middleNameFormatter(
                      memorialData?.firstName,
                      memorialData?.middleName,
                      memorialData?.lastName,
                      true
                    )
                  )
                )}
              </h1>
              <>
                {memorialData?.birthDate !== null && (
                  <div className="txt">
                    {dayJsDateFormatter(memorialData?.birthDate, DateFormatess)}{" "}
                    {memorialData?.deathDate &&
                      `- ${dayJsDateFormatter(
                        memorialData?.deathDate,
                        DateFormatess
                      )}`}
                  </div>
                )}
                {memorialData?.location && (
                  <span className="d-flex align-items-center txt">
                    <em className="icon-location" />
                    {getLocation(memorialData?.location)}
                  </span>
                )}
              </>
              {memorialData?.myBio && <p>{memorialData?.myBio}</p>}
              <div className="d-flex align-items-center justify-content-between">
                {/* Social Icons */}
                <ul className="list-inline mb-0 banner_cnt_social">
                  {memorialData?.instagram && (
                    <li className="list-inline-item">
                      <Link
                        to={memorialData?.instagram}
                        target="_blank"
                        className="d-flex align-items-center justify-content-center"
                        aria-label="instagram"
                      >
                        <em className="icon-instagram" />
                      </Link>
                    </li>
                  )}
                  {memorialData?.twitter && (
                    <li className="list-inline-item">
                      <Link
                        to={memorialData?.twitter}
                        target="_blank"
                        className="d-flex align-items-center justify-content-center"
                        aria-label="twitter"
                      >
                        <em className="icon-twitter" />
                      </Link>
                    </li>
                  )}
                  {memorialData?.facebook && (
                    <li className="list-inline-item">
                      <Link
                        to={memorialData?.facebook}
                        target="_blank"
                        className="d-flex align-items-center justify-content-center"
                        aria-label="facebook"
                      >
                        <em className="icon-facebook" />
                      </Link>
                    </li>
                  )}
                  {role === "user" && !isModal && (
                    <li className="list-inline-item">
                      <Link
                        to="#"
                        aria-label="report"
                        className="d-flex align-items-center justify-content-center"
                        onClick={(e) => {
                          e.preventDefault();
                          setReportModal(true)
                        }}
                      >
                        <em className="icon-report" />
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </Container>
        </div>
      </div>
      {showReportModal && (
        <ReportCategory
          setReportModal={setReportModal}
          showReportModal={showReportModal}
          id={id}
        />
      )}
    </>
  );
}

export default AboutSection;
